export const DefaultInputHeight = 32;
export const HardSpace = '\u00A0';
